<template>
    <v-app>
        <div class="text-center">
            <v-dialog
                v-model="$parent.deleteModalDialog"
                width="500"
            >
                <v-card>
                    <v-card-title class="text-h6 grey lighten-2">
                        Delete
                    </v-card-title>

                    <v-card-text class="pt-3 pb-0">
                        Are you sure you want to do this?
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions class="pt-0">

                        <v-spacer></v-spacer>

                        <v-progress-circular
                            v-if="loading"
                            :width="2"
                            :size="25"
                            indeterminate
                            color="#fb7e42"
                            class="mr-2"
                        ></v-progress-circular>

                        <v-btn
                            color="primary"
                            text
                            @click="closeModalDialog"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                            :disabled="loading"
                            color="error"
                            text
                            @click="deleteItem"
                        >
                            Delete
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </v-app>
</template>

<script>
export default {
    name: "DeleteModal",
    data: () => ({
        loading: false,
    }),
    methods: {
        deleteItem() {
            this.loading = true
            this.$parent.deleteItem()
        },
        closeModalDialog() {
            this.$parent.deleteModalDialog = false
        }
    }
}
</script>

<style scoped>

.v-dialog__content--active {
    z-index: 99999 !important;
}

</style>